<div class="d-flex mt-2 row">
  <div class="col-md-4">
    <mat-form-field style="margin-right: 20px" appearance="outline">
      <mat-label>Enter week date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate1" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate1" placeholder="End date" (dateChange)="onEndDateChanged()">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="col-md-2">
    <button mat-mini-fab (click)="SearchData()" color="accent" permission="Weekly Report" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="clearAll()" color="accent" style="margin-left: 10px;">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>

<div class="d-flex flex-wrap">
  <mat-card class="col-md-12 col-sm-12 mb-4">
    <!--      <div  class="d-flex justify-content-end mb-2">-->
    <!--        <button mat-raised-button  (click)="exportexcel()" color="primary">  <mat-icon> cloud_download</mat-icon> &nbsp; Download Table </button>-->
    <!--      </div>-->
    <!--        <mat-form-field>-->
    <!--            <mat-label>Enter week date range</mat-label>-->
    <!--            <mat-date-range-input  [rangePicker]="picker2">-->
    <!--                <input matStartDate [(ngModel)]="startDate2" placeholder="Start date">-->
    <!--                <input matEndDate [(ngModel)]="endDate2" placeholder="End date">-->
    <!--            </mat-date-range-input>-->
    <!--            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>-->
    <!--            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>-->
    <!--            <mat-date-range-picker #picker2></mat-date-range-picker>-->
    <!--        </mat-form-field>-->
    <!--        <h3 class="text-center rounded text-white">Occupancy Report <span *ngIf="startDate1">{{startDate1|date:'dd/MM/yyyy'}}</span><span *ngIf="endDate1">  -  {{endDate1|date:'medium'}}</span> </h3>-->
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Weekly Occupancy Report <span *ngIf="startDate1">{{startDate1|date:'dd/MM/yyyy'}}</span><span *ngIf="endDate1">  -  {{endDate1|date:'dd/MM/yyyy'}}</span></h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" id="search-input" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">

        <li>
          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Weekly Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]" >
            <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort id="excel-table">

      <!-- Position Column -->
      <ng-container matColumnDef="centername">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"
            [matTooltip]="element.centreCode"> {{element?.centreName}} </td>
        <!--                <td mat-footer-cell *matFooterCellDef><strong> Total</strong> </td>-->

      </ng-container>


      <!-- Available Units  Column -->
      <ng-container matColumnDef="availableunits">
        <th mat-header-cell *matHeaderCellDef> Available </th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="element.isArchive?'archived':'normal'"> {{element?.Available}}   </td>
        <!--                <td mat-footer-cell *matFooterCellDef> <strong>{{lastRow?.availableUnits}}</strong> </td>-->

      </ng-container>
      <!-- Weight Column -->
      <ng-container matColumnDef="occupiedunits">
        <th mat-header-cell *matHeaderCellDef> Occupied As Of  <br>{{startDate1 |date:'dd/MM/yyyy'}} </th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="element.isArchive?'archived':'normal'"> {{element?.Occupied}} </td>
        <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

      </ng-container>
      <ng-container matColumnDef="occupiedunitsEnd">
        <th mat-header-cell *matHeaderCellDef> Occupied As Of <br> {{endDate1 |date:'dd/MM/yyyy'}} </th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="element.isArchive?'archived':'normal'"> {{element?.OccupiedEnd}} </td>
        <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

      </ng-container>
      <ng-container matColumnDef="difference">
        <th mat-header-cell *matHeaderCellDef> Difference  </th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="element.isArchive?'archived':'normal'"> {{Math.abs(element.Occupied - element?.OccupiedEnd)}} </td>
        <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

      </ng-container>
      <!-- Weight Column -->
      <ng-container matColumnDef="totalunits">
        <th mat-header-cell *matHeaderCellDef> Total Rooms</th>
        <td mat-cell *matCellDef="let element"
            [ngClass]="element.isArchive?'archived':'normal'"> {{element?.totalRooms}} </td>
        <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.totalUnits}}</strong> </td>-->

      </ng-container>
      <ng-container matColumnDef="percentage">
        <th mat-header-cell *matHeaderCellDef> Occupancy %</th>
        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive ? 'archived' : 'normal'">
          <span *ngIf="element">{{ element.Occupancy | number:'1.1-1'}}%</span>
        </td>

        <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

      </ng-container>


<!--      <ng-container matColumnDef="admission">-->
<!--        <th mat-header-cell *matHeaderCellDef> New Admission</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.uniqueAdmission !== 0 ? element.uniqueAdmission : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="discharge">-->
<!--        <th mat-header-cell *matHeaderCellDef> Discharge</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.uniqueDischarge !== 0 ? element.uniqueDischarge : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="fAdmission">-->
<!--        <th mat-header-cell *matHeaderCellDef> Follow Up Admission</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.followUpAdmission !== 0 ? element.followUpAdmission : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="fDischarge">-->
<!--        <th mat-header-cell *matHeaderCellDef> Follow Up Discharge</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.followupDischarge !== 0 ? element.followupDischarge : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="os">-->
<!--        <th mat-header-cell *matHeaderCellDef> OS</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.os!== 0 ? element.os : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="dama">-->
<!--        <th mat-header-cell *matHeaderCellDef> DAMA</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.dama!== 0 ? element.dama : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
<!--      <ng-container matColumnDef="alchamp">-->
<!--        <th mat-header-cell *matHeaderCellDef> Always Champion</th>-->
<!--        <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.alwaysChamp!== 0 ? element.alwaysChamp : '-'}}</span></td>-->
<!--        &lt;!&ndash;                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>&ndash;&gt;-->

<!--      </ng-container>-->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!--            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>-->

      <!-- Row shown when there is no matching data. -->
      <!--            <tr *matNoDataRow class="mat-row">-->
      <!--                <td class="mat-cell" colspan="4"  >No data matching the filter "{{input.value}}"</td>-->
      <!--            </tr>-->
    </table>
  </mat-card>

  <div class=" mt-4 col-md-12 mb-5 height-auto ">
    <!--        <app-financial-report-table></app-financial-report-table>-->
  </div>
</div>
<section *ngIf="showLog">
  <div class="row">
    <h2>{{startDate1}}</h2>
    <div class="col-md-6">
      <!--        <prettyjson [obj] =pList></prettyjson>-->


    </div>
    <div class="col-md-6">
      <!--        <prettyjson [obj] =admittedList></prettyjson>-->

    </div>
  </div>
  <hr>

  <div class="row">
    <h2>{{endDate1}}</h2>
    <div class="col-md-6">
      <!--            <prettyjson [obj] =pList2></prettyjson>-->


    </div>
    <div class="col-md-6">
      <!--            <prettyjson [obj] =admittedList></prettyjson>-->

    </div>
  </div>
</section>
